export enum ModalType {
    AddToCart = "add-to-cart",
    ForgotPassword = "forgot-password",
    Cashback = "cashback-modal",
    ReviewWrite = "review-write",
    ReviewGuidance = "review-guidance",
    ReviewTermsAndConditions = "review-terms-and-conditions",
    ReviewPhotoGuidance = "review-photo-guidance",
    ImageViewer = "image-viewer",
    EnergyLabel = "energy-label",
    TransportService = "transport-service",
    HasAccount = "has-account",
    NewsletterUnsubscribe = "newsletter-unsubscribe-modal"
}

export const $ModalModuleName = "modal";

export type ModalId = ModalType | `${ModalType}-${string}`;

export type TModalState = Array<ModalId>;
